<template>
    <li class="list-group-item task" v-bind:class="{'text-cancelled': isTaskCancelled || isTaskBookingCancelled}">
        <div class="row">
            <div class="col-1 task-icon" v-on:mouseenter="showTooltip = true" v-on:mouseleave="showTooltip = false">
                <div class="tooltip-container">
                    <span v-html="taskIcon"></span>
                    <span v-html="taskStateIcon"></span>
                    <tooltip v-bind:visible="showTooltip" v-bind:position="'right'" v-bind:text="tooltipTextForTaskState"></tooltip>
                </div>
            </div>
            <div v-bind:class="{'col-4': task.booking && task.booking.bookedBy, 'col-9': !task.booking || !task.booking.bookedBy}" class="task-name">
                {{taskName}}
            </div>
            <div class="col-5 guest-name" v-if="task.booking && task.booking.bookedBy" v-on:click.stop="showTrip">
                {{task.booking.bookedBy.firstName}} {{task.booking.bookedBy.lastName}}
            </div>
            <div class="col-2 text-right">
                <button v-if="isTaskScheduled" type="button" class="btn btn-secondary task-button task-button--scheduled" v-on:click.stop="showTask">
<!--                    <i class="far fa-clock"></i> -->
                    {{friendlyTime(task.scheduledDate)}}
                </button>
                <button v-else type="button" class="btn btn-secondary task-button" v-on:click.stop="showTask">
                    <i v-if="hasActions" class="fas fa-edit"></i>
                    <i v-if="!hasActions" class="fas fa-eye"></i>
<!--                    ...-->
                </button>
<!--                <button v-else-if="hasActions" type="button" class="btn btn-secondary task-button" v-on:click.stop="toggleActions">...</button>-->
<!--                <template v-else>{{actionDoneText}}</template>-->
            </div>
            <div v-if="hasActions && showActions">
                <div class="highlight-task-close-hitbox" v-on:click="toggleActions"></div>
                <div class="highlight-task" v-on:click.stop="toggleActions"></div>
                <div class="task-button-actions" v-on:focus="hideActions">
                    <div class="task-button-action" v-if="isMarkDoneAction" v-on:click="openForm">
                        <i class="fas fa-check"></i> Mark done
                    </div>
                    <div class="task-button-action" v-if="isComposeAction" v-on:click="openForm">
                        <i class="fas fa-envelope"></i> Compose
                    </div>
                    <div class="task-button-action" v-if="isViewAction" v-on:click="openForm">
                        <i class="fas fa-envelope-open-text"></i> View / Edit
                    </div>
                    <div class="task-button-action" v-if="isCheckOutAction" v-on:click="openForm">
                        <i class="fas fa-concierge-bell"></i> Check out
                    </div>
                    <div class="task-button-action" v-if="isCheckInAction" v-on:click="openForm">
                        <i class="fas fa-concierge-bell"></i> Check in
                    </div>
                    <div class="task-button-action" v-if="isRescheduleAction" v-on:click="openForm">
                        <i class="far fa-clock"></i> Reschedule
                    </div>
                    <div class="task-button-action" v-if="isIgnoreAction" v-on:click="openForm">
                        <i class="fas fa-ban"></i> Ignore
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showTaskDetails">
            <TaskDetails v-bind:task="this.task"></TaskDetails>
        </div>
        <div v-if="showTripDetails">
            <TripDetails v-bind:booking="this.task.booking"></TripDetails>
        </div>
    </li>
</template>

<script>
    import TaskDetails from "./TaskDetails";
    import TripDetails from "../bookings/TripDetails";
    import Tooltip from "../Tooltip";
    import { tasksMixin } from '../../mixins/TasksMixin'
    import { datesMixin } from '../../mixins/DatesMixin'

    export default {
        name: 'Task',
        components: { TaskDetails, TripDetails, Tooltip },
        mixins: [tasksMixin, datesMixin],
        props: {
            task : Object,
        },
        data: function () {
            return {
                showActions: false,
                showTaskDetails: false,
                showTripDetails: false,
                showTooltip: false
            }
        },
        computed: {
        },
        methods: {
            toggleActions: function () {
                this.showActions = !this.showActions
            },
            hideActions: function () {
                this.showActions = false
            },
            openForm: function () {
                this.$router.push({ name: 'ViewForm', params: { reference: this.task.formResponseReference } })
                // console.log('Open form')
            },
            showTask: function () {
                this.showTaskDetails = true
            },
            hideTask: function () {
                this.showTaskDetails = false
            },
            taskUpdated: function (task) {
                if (this.task.reference === task.reference) {
                    console.log("task updated: " + task.reference);
                    Object.assign(this.task, task);
                }
            },
            showTrip: function () {
                this.showTripDetails = true
            },
            hideTrip: function () {
                this.showTripDetails = false
            },
        },
        mounted() {
            this.$root.$on('task-updated', this.taskUpdated);
            this.$root.$on('finished-viewing-trip-details', this.hideTrip);
            this.$root.$on('finished-viewing-task-details', this.hideTask);
        },
        beforeDestroy () {
            this.$root.$off('task-updated', this.taskUpdated);
            this.$root.$off('finished-viewing-trip-details', this.hideTrip);
            this.$root.$off('finished-viewing-task-details', this.hideTask);
        }
    }
</script>

<!--These are overrides for the flatpickr inputs -->
<style lang="scss">
    @import "../../styles/overrides/flatpickr";

    .day-of-tasks:hover {

        .task-button {
            background-color: $grey-light;
            border-color: $grey-light;
            color: $grey-medium;
        }
    }
</style>

<style lang="scss" scoped>
    @import "../../styles/components/task";
</style>

